import React from 'react'
import Navbar from "../components/Navbar/Navbar";
import Courses from "../container/Courses/Courses";
import Footer from '../components/Footer/Footer';
const Kurslar = () => {
  return (
    <>
        <Navbar/>
        <Courses/>
        <Footer/>
    </>
  )
}

export default Kurslar